import React from 'react';
import * as LucideIcons from 'lucide-react';
import { motion } from 'framer-motion';

const BottomNavigation = ({ currentPage, handlePageChange, unreadMessages, user, userId, setShowCreateModal, setIsDrawerOpen }) => {
    if (!user || user.isAnonymous) {
        return null;
    }

    const navItems = [
        { id: 'anonymousFeed', icon: 'Home', label: 'Feed' },
        { id: 'users', icon: 'Search', label: 'Discover' },
        { id: 'create', icon: 'Plus', label: '', isAction: true },
        { id: 'messages', icon: 'MessageCircle', label: 'Chat', badge: unreadMessages ? true : false },
        { id: 'menu', icon: 'Menu', label: 'Menu', isMenu: true }
    ];

    return (
        <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-center pb-[env(safe-area-inset-bottom)] pointer-events-none">
            <div className="glass-nav-pill rounded-full px-6 py-3 flex justify-between items-center w-full max-w-md pointer-events-auto shadow-2xl">
                {navItems.map(item => {
                    const IconComponent = LucideIcons[item.icon];
                    const isActive = currentPage === item.id;
                    
                    if (item.isAction) {
                        return (
                            <motion.button 
                                key={item.id}
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => setShowCreateModal(true)}
                                className="bg-indigo-500 text-white rounded-full p-3 shadow-lg shadow-indigo-500/40 transform -translate-y-4"
                            >
                                <IconComponent size={24} strokeWidth={2.5} />
                            </motion.button>
                        );
                    }

                    return (
                        <button 
                            key={item.id}
                            onClick={() => {
                                if (item.isMenu) {
                                    if (typeof setIsDrawerOpen === 'function') setIsDrawerOpen(true);
                                } else {
                                    handlePageChange(item.id);
                                }
                            }}
                            className={`flex flex-col items-center justify-center relative transition-all duration-300 ${isActive ? 'text-indigo-400' : 'text-gray-400 hover:text-gray-200'}`}
                        >
                            <div className="relative">
                                <IconComponent size={24} strokeWidth={isActive ? 2.5 : 2} className={isActive ? "drop-shadow-[0_0_8px_rgba(99,102,241,0.6)]" : ""} />
                                {item.badge && (
                                    <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border border-black shadow-lg shadow-red-500/50 animate-pulse"></span>
                                )}
                            </div>
                            <span className="text-[10px] mt-1 font-medium">{item.label}</span>
                            
                            {/* Active Dot Indicator */}
                            {isActive && (
                                <motion.div 
                                    layoutId="bottomNavIndicator"
                                    className="absolute -bottom-2 w-1 h-1 bg-indigo-400 rounded-full shadow-[0_0_8px_rgba(99,102,241,0.8)]" 
                                />
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default BottomNavigation;
